<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 16:01:40
 * @LastEditTime: 2020-06-21 16:30:48
 * @Description: 数据表格分页
 -->
<template>
   <i-page
    :total="total"
    :page-size="page.size"
    size="small"
    show-elevator show-total @on-change="pageIndexChangedHandler" />
</template>

<script>
export default {
  name: 'DataPage',
  props: {
    total: { type: Number, required: true },
    page: { type: Object, reuqired: true },
  },
  methods: {
    /**
     * 分页索引发生改变处理函数
     */
    pageIndexChangedHandler(index) {
      this.$emit('index-change', index);
    },
  },
};
</script>
